import { css } from 'styled-components';

export const Charts = css`
  svg > g > g > rect {
    fill: #fff;
  }
`;
